document.addEventListener("DOMContentLoaded", () => {

  const ranges = [
    { min: 1,   max: 50       },
    { min: 51,  max: 100      },
    { min: 101, max: Infinity }
  ];

  function getQtyInput() {
    return document.querySelector('quantity-input input');
  }

  function getRadios() {
    return document.querySelectorAll('variant-selects input[name^="Area-1"]');
  }

  function getVariantIndexByQty(qty) {
    return ranges.findIndex(r => qty >= r.min && qty <= r.max);
  }

  function getSelectedVariantIndex() {
    const radios = getRadios();
    for (let i = 0; i < radios.length; i++) {
      if (radios[i].checked) return i;
    }
    return 0;
  }

  // Track the intended qty so we can restore it after Dawn resets
  let intendedQty = null;
  let observerLocked = false;

  function applyIntendedQty() {
    const qtyInput = getQtyInput();
    if (!qtyInput || intendedQty === null) return;
    if (parseInt(qtyInput.value) !== intendedQty) {
      qtyInput.value = intendedQty;
    }
  }

  // Watch the qty input for Dawn silently resetting it to 1
  function observeQtyInput() {
    const qtyInput = getQtyInput();
    if (!qtyInput) return;

    const observer = new MutationObserver(() => {
      if (observerLocked) return;
      const current = parseInt(qtyInput.value);
      if (intendedQty !== null && current !== intendedQty) {
        // Dawn reset us — restore after its microtask settles
        requestAnimationFrame(() => {
          qtyInput.value = intendedQty;
        });
      }
    });

    observer.observe(qtyInput, {
      attributes: true,
      attributeFilter: ['value'],
      childList: false,
      subtree: false,
      characterData: true
    });

    // Also watch via the value property setter (Dawn uses JS assignment)
    const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    Object.defineProperty(qtyInput, 'value', {
      get() { return descriptor.get.call(this); },
      set(v) {
        if (observerLocked) {
          descriptor.set.call(this, v);
          return;
        }
        // If Dawn tries to reset to 1 and we have an intended qty, block it
        if (intendedQty !== null && parseInt(v) === 1 && intendedQty > 1) {
          descriptor.set.call(this, intendedQty);
        } else {
          descriptor.set.call(this, v);
        }
      },
      configurable: true
    });
  }

  /* Quantity → Variant */
//   function updateVariant() {
//     const qtyInput = getQtyInput();
//     const radios = getRadios();
//     if (!qtyInput || radios.length === 0) return;

//     const qty = parseInt(qtyInput.value) || 1;
//     intendedQty = qty; // remember before Dawn can reset
//     const idx = getVariantIndexByQty(qty);

//     if (idx !== -1 && !radios[idx].checked) {
//       radios[idx].checked = true;
//       radios[idx].dispatchEvent(new Event('change', { bubbles: true }));
//     }
//   }

  /* Variant → Quantity */
//   function enforceMinQty() {
//     const qtyInput = getQtyInput();
//     const radios = getRadios();
//     if (!qtyInput || radios.length === 0) return;

//     const idx = getSelectedVariantIndex();
//     const min = ranges[idx].min;
//     const qty = parseInt(qtyInput.value) || 1;

//     if (qty < min) {
//       observerLocked = true;
//       intendedQty = min;
//       qtyInput.value = min;
//       qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
//       observerLocked = false;
//     } else {
//       // Restore intended qty if Dawn wiped it
//       applyIntendedQty();
//     }
//   }

let variantChangedByQty = false;

/* Quantity → Variant */
function updateVariant() {
  const qtyInput = getQtyInput();
  const radios = getRadios();
  if (!qtyInput || radios.length === 0) return;

  const qty = parseInt(qtyInput.value) || 1;
  intendedQty = qty;
  const idx = getVariantIndexByQty(qty);

  if (idx !== -1 && !radios[idx].checked) {
    variantChangedByQty = true; // mark that WE changed the variant
    radios[idx].checked = true;
    radios[idx].dispatchEvent(new Event('change', { bubbles: true }));
  }
}

/* Variant → Quantity */
function enforceMinQty() {
  if (variantChangedByQty) {
    variantChangedByQty = false; // skip, qty already correct
    return;
  }

  const qtyInput = getQtyInput();
  const radios = getRadios();
  if (!qtyInput || radios.length === 0) return;

  const idx = getSelectedVariantIndex();
  const min = ranges[idx].min;

  observerLocked = true;
  intendedQty = min;
  qtyInput.value = min;
  qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  observerLocked = false;
}

  /* Events */
  document.addEventListener("input", (e) => {
    if (e.target.matches("quantity-input input")) {
      intendedQty = parseInt(e.target.value) || 1;
      updateVariant();
    }
  });

  document.addEventListener("click", (e) => {
    if (e.target.closest("button.quantity__button")) {
      setTimeout(() => {
        intendedQty = parseInt(getQtyInput()?.value) || 1;
        updateVariant();
      }, 10);
    }
  });

  document.addEventListener("change", (e) => {
    if (e.target.matches('variant-selects input[name^="Area-1"]')) {
      setTimeout(enforceMinQty, 50); // bumped from 10ms → 50ms to beat Dawn's async reset
    }
  });

// Init: set qty to min of the default selected variant on first load
function initQty() {
  const qtyInput = getQtyInput();
  const radios = getRadios();
  if (!qtyInput || radios.length === 0) return;

  const idx = getSelectedVariantIndex();
  const min = ranges[idx].min;

  observerLocked = true;
  intendedQty = min;
  qtyInput.value = min;
  observerLocked = false;
}

// Init observer once DOM is ready
observeQtyInput();
initQty(); // <-- add this
});